import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { IMeetingRoomSettingsDays } from 'domain/feature/meeting-room/shared/types'
import {
  getClosedDatesInRange,
  getClosedWeekdayKeys,
  MeetingRoomWeekdayKey,
} from 'domain/feature/meeting-room/shared/workingDays'
import i18n from 'sharedKernel/i18n/translate/config'

const CLOSED_WEEKDAY_LABELS: Record<MeetingRoomWeekdayKey, string> = {
  monday: 'às segundas-feiras',
  tuesday: 'às terças-feiras',
  wednesday: 'às quartas-feiras',
  thursday: 'às quintas-feiras',
  friday: 'às sextas-feiras',
  saturday: 'aos sábados',
  sunday: 'aos domingos',
}

const formatList = (items: string[]): string => {
  if (items.length <= 1) return items[0] ?? ''
  return `${items.slice(0, -1).join(', ')} e ${items[items.length - 1]}`
}

export const getClosedDaysAttentionMessage = (
  startDate: string,
  endDate: string,
  workingDays: IMeetingRoomSettingsDays | null | undefined
): string => {
  if (!workingDays) return ''

  const closedDates = getClosedDatesInRange(startDate, endDate, workingDays)
  if (closedDates.length === 0) return ''

  const weekdays = getClosedWeekdayKeys(workingDays).map(day => CLOSED_WEEKDAY_LABELS[day])
  const dates = closedDates.map(date => format(date, "d 'de' MMMM", { locale: ptBR }))

  return String(
    i18n.t('meetingRoom.public.form.calendar.rangeClosedDaysAttention', {
      count: closedDates.length,
      weekdays: formatList(weekdays),
      dates: formatList(dates),
    })
  )
}
